import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ContactsService } from "@boxx/contacts-core/lib/services/contacts.service";
import { SharedComponentsModule } from "@boxx/shared-components";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { NgxPermissionsModule } from "ngx-permissions";
import { PipesModule } from "src/pipes/pipes.module";
import { AppointmentItemComponent } from "./appointment-item/appointment-item.component";
import { EventCreateComponent } from "./event-create-modal/event-create.modal";
import { EventFormComponent } from "./event-form/event-form.component";

@NgModule({
  declarations: [
    AppointmentItemComponent,
    EventCreateComponent,
    EventFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    SharedComponentsModule,
    PipesModule,
    NgxPermissionsModule.forChild(),
  ],
  exports: [AppointmentItemComponent, EventCreateComponent, EventFormComponent],
  providers: [ContactsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventsCoreComponentsModule {}
